import Form, { Field as BaseField } from "rc-field-form";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Input } from "reactstrap";
import Button from "../../../../../../../../components/Button";
import Field from "../../../../../../../../components/Field";
import Checkbox from "../../../../../../../../components/Inputs/Checkbox";
import HourTypeSelect from "../../../../../../../../components/Inputs/HourTypeSelect";
import ResourceSelect from "../../../../../../../../components/Inputs/ResourceSelect";
import Switch from "../../../../../../../../components/Inputs/Switch";
import {
	getPathWithParams,
	getSettingsResourceSearchFilters,
	renderSettingsResourceLabel
} from "../../../../../../../../utils/helpers/settings";
import { payCodeCalcFields } from "../../../../helper";
import PayCodeSelect from "../../PayCodeSelect";

function Details({ values, disabled, close }) {
	const { t } = useTranslation();
	const [hidden, setHidden] = useState(false);

	const onChange = useCallback(
		(e) => setHidden(!e.target.checked),
		[setHidden],
	);

	return (
		<Form
			name="base-holiday-rule"
			onFinish={close}
			labelAlign="left"
			labelCol={{ span: 8 }}
			wrapperCol={{ span: 14, offset: 2 }}
			colon={false}
			initialValues={{ holidayRules: values }}
			scrollToFirstError
		>
			<Field
				label={t("amount")}
				name={["holidayRules", "base", "amount"]}
				rules={[
					{
						required: true,
						message:
							t("required-amount"),
					},
					{
						validator(_, value) {
							if (Number(value) < 0) {
								return Promise.reject(new Error(t("amount-bigger-than-zero")))
							}
							return Promise.resolve()
						}
					}
				]}
			>
				<Input
					type="number"
					min={0}
					step="0.1"
					placeholder={t("amount")}
					disabled={disabled}
				/>
			</Field>

			<BaseField shouldUpdate noStyle>
				{({ }, { }, { setFieldValue }) => {
					return (
						<Field
							name={["holidayRules", "base", "baseAmountOnSchedule"]}
							label={t("base-amount-on-schedule")}
							valuePropName="checked"
						>
							<Switch
								disabled={disabled}
								// onChange={(e) => {
								// 	if (e.target.checked) {
								// 		setFieldValue(["holidayRules", "base", "baseAmountOnExpectedHours"], false);
								// 	}
								// }}
							/>
						</Field>
					);
				}}
			</BaseField>

			{/* <BaseField shouldUpdate noStyle>
				{({ }, { }, { setFieldValue }) => {
					return (
						<Field
							name={["holidayRules", "base", "baseAmountOnExpectedHours"]}
							label={t("base-amount-on-expected-hours")}
							valuePropName="checked"
						>
							<Switch
								disabled={disabled}
								onChange={(e) => {
									if (e.target.checked) {
										setFieldValue(["holidayRules", "base", "baseAmountOnSchedule"], false);
									}
								}}
							/>
						</Field>
					);
				}}
			</BaseField> */}

			<Field
				label={t("pay-code")}
				name={["holidayRules", "base", "payCode"]}
				rules={[
					{
						required: true,
						message: t("required-pay-code")
					}
				]}
			>
				<ResourceSelect
					labelPropName="description"
					renderLabel={renderSettingsResourceLabel}
					resourcePath={getPathWithParams('/pay-code', true, {}, payCodeCalcFields, {
						hourType: 'unit',
					})}
					placeholder={t("pay-code")}
					hasSearch
					getSearchFilters={getSettingsResourceSearchFilters}
					disabled={disabled}
					allowClear
				/>
			</Field>

			<BaseField shouldUpdate noStyle>
				{({ }, { }, { getFieldValue, setFieldValue }) => {
					const payCodes = getFieldValue(["holidayRules", "base", "payCodes"]);
					const onChange = (hourTypes) => {
						setFieldValue("payCodes", payCodes?.filter((payCode) =>
							hourTypes.includes(payCode.hourType),
						));
					};

					return (
						<Field
							label={t("eligible-hour-types")}
							name={["holidayRules", "base", "hourTypes"]}
						>
							<HourTypeSelect
								mode="multiple"
								placeholder={t("eligible-hour-types")}
								onChange={onChange}
								disabled={disabled}
							/>
						</Field>
					);
				}}
			</BaseField>

			<div className="mb-3">
				<Field
					name={["holidayRules", "base", "shouldWorkPreviousSchedule"]}
					valuePropName="checked"
				>
					<Checkbox disabled={disabled} id="shouldWorkPreviousSchedule">
						{t("must-work-the-scheduled-day-before-the-holiday")}
					</Checkbox>
				</Field>
			</div>

			<div className="mb-3">
				<Field
					name={["holidayRules", "base", "shouldWorkNextSchedule"]}
					valuePropName="checked"
				>
					<Checkbox disabled={disabled} id="shouldWorkNextSchedule">
						{t("must-work-the-scheduled-day-after-the-holiday")}
					</Checkbox>
				</Field>
			</div>

			<div className="mb-3">
				<Checkbox
					checked={!hidden}
					onChange={onChange}
					id="show-pay-code"
					disabled={disabled}
				>
					{t("show-eligible-pay-code")}
				</Checkbox>
			</div>

			<BaseField shouldUpdate>
				{({ }, { }, { getFieldValue }) =>
					!hidden && (
						<PayCodeSelect
							hourTypes={getFieldValue(["holidayRules", "base", "hourTypes"])}
							name={["holidayRules", "base", "payCodes"]}
							hidden={hidden}
							disabled={disabled}
						/>
					)
				}
			</BaseField>

			<div className="d-flex justify-content-between my-2">
				{disabled ? (
					<div />
				) : (
					<Button
						type="submit"
						color="primary"
						size="xs"
						className="bg-dark"
					>
						{t("save-changes")}
					</Button>
				)}

				<Button
					size="small"
					className="border-primary-color mr-1"
					onClick={close}
				>
					{t("close")}
				</Button>
			</div>
		</Form>
	);
}

export default Details;
